import { SkyscannerExplorepricingserviceV1ExplorePricing } from '@skyscanner-internal/explore-pricing-service-web-http-client';

import { grpcFetchClientWrapper } from '../../internals/clients/grpc/grpc';

export type { SkyscannerExplorepricingserviceV1ExplorePricing } from '@skyscanner-internal/explore-pricing-service-web-http-client';

export const GRPC_EXPLORE_PRICING_GET_INDICATIVE_PRICES_CLIENT_NAME =
  'EXPLORE_PRICING_GET_INDICATIVE_PRICES';
export const GRPC_EXPLORE_PRICING_GET_MONTHLY_INDICATIVE_PRICES_CLIENT_NAME =
  'EXPLORE_PRICING_GET_MONTHLY_INDICATIVE_PRICES';
export const PATH_PREFIX = '/g/explore-pricing-service';

export const getIndicativePrices = grpcFetchClientWrapper(
  SkyscannerExplorepricingserviceV1ExplorePricing.ExplorePricingService.GetIndicativePrices,
  {
    clientName: GRPC_EXPLORE_PRICING_GET_INDICATIVE_PRICES_CLIENT_NAME,
    pathPrefix: PATH_PREFIX,
  },
);

export const getMonthlyIndicativePrices = grpcFetchClientWrapper(
  SkyscannerExplorepricingserviceV1ExplorePricing.ExplorePricingService.GetMonthlyIndicativePrices,
  {
    clientName: GRPC_EXPLORE_PRICING_GET_MONTHLY_INDICATIVE_PRICES_CLIENT_NAME,
    pathPrefix: PATH_PREFIX,
  },
);
